<template>
  <div id="app">
    <!-- 用 keep-alive 包裹 router-view -->
    <keep-alive>
      <!-- 如果当前路由配置了 keepAlive: true，则走这里（会被缓存） -->
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>

    <!-- 如果没有配置 keepAlive，或者为 false，则走这里（不会被缓存） -->
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
